import React from "react";
import { Box, Flex, Text } from "@catchoftheday/cg-components";
import { CurrentBenefit } from "./CurrentBenefit";
import { FreeDelivery } from "./FreeDelivery";
import { PersonalisedOffer } from "./PersonalisedOffer";
import { jsx as ___EmotionJSX } from "@emotion/react";
export var DesktopWrapper = function DesktopWrapper() {
  return ___EmotionJSX(Flex, {
    alignItems: "stretch"
  }, ___EmotionJSX(Box, {
    py: 7,
    px: 6,
    borderRadius: "corner",
    borderColor: "onePass.primaryDarker",
    borderStyle: "solid",
    borderWidth: "1px",
    overflow: "hidden",
    height: "100%"
  }, ___EmotionJSX(CurrentBenefit, null)), ___EmotionJSX(Box, {
    alignSelf: "center"
  }, ___EmotionJSX(Text, {
    textAlign: "center",
    color: "onePass.primaryDarker",
    fontWeight: "bold",
    fontSize: "base",
    my: "auto",
    mx: 4,
    whiteSpace: "nowrap"
  }, "+ PLUS")), ___EmotionJSX(Flex, {
    height: "100%",
    py: 7,
    px: 6,
    backgroundColor: "onePass.primaryDarker",
    color: "white",
    borderRadius: "corner",
    borderColor: "onePass.primaryDarker",
    borderStyle: "solid",
    borderWidth: "1px",
    overflow: "hidden",
    alignItems: "center"
  }, ___EmotionJSX(Box, {
    width: "50%",
    pr: 4,
    borderColor: "white",
    borderStyle: "solid",
    borderWidth: 0,
    borderRightWidth: "1px"
  }, ___EmotionJSX(FreeDelivery, null)), ___EmotionJSX(Box, {
    width: "50%",
    pl: 4
  }, ___EmotionJSX(PersonalisedOffer, null))));
};